// src/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://cms.lloret.cat/rest',
  // You can add any additional configuration here, such as headers, timeout, etc.
});

// export const getNews = () => api.get('/news/?_' + page );



export async function getNews(page = 0) {
    return api.get('/news?page=' + page )
}

export async function getNewsDetail(nid) {
  return api.get('/news/?nid=' + nid )
}